export default __webpack_public_path__ + "static/media/passkey.00b17051.png";